import { Avatar, Box, Button, Group, Switch, Text, Title } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import React, { useState } from "react";
import { FaEnvelopeOpen } from "react-icons/fa";
import { GET_COMPANY_INTEGRATION, SET_COMPANY_INTEGRATION } from "../../services/companies";
import InputField, { InputFieldTypes } from "../input_field";

export default function Sendgrid() {
    const [data, setData] = useState<any>(null);
    const [loadingSave, setLoadingSave] = useState<boolean>(false);
    const [isValid, setIsValid] = useState<boolean>(false);
    const [template, setTemplate] = useState<string>("");

    const loadData = () => {
        GET_COMPANY_INTEGRATION("sendgrid")
            .then((res) => {
                setData(res)
            })
            .catch(err => {
                notifications.show({ title: "Ops.", message: err.message, color: 'red' })
            })
    }

    const handleSave = () => {
        setLoadingSave(true)

        SET_COMPANY_INTEGRATION("sendgrid", { ...data })
            .then((res) => {
                setLoadingSave(false);
                loadData()
                notifications.show({ message: "Template ID Configured", color: 'green' })
            })
            .catch(err => {
                setLoadingSave(false)
                notifications.show({ title: "Ops.", message: err.message, color: 'red' })
            })
    }

    React.useEffect(() => {
        setIsValid(
            { ...data }.api_key &&
            { ...data }.from_email &&
            (!{ ...data }[template] || ({ ...data }[template] ?? "").includes("d-"))
        );
    }, [data]);

    React.useEffect(() => { loadData() }, [])

    return <>
        <Group>
            <Avatar size={40} src="/assets/sendgrid.png" />
            <Title c="gray.0" style={{ flex: 1 }} order={5}>SendGrid</Title>
            <Switch onChange={() => {
                let enabled = !data?.enabled;
                setData(d => ({ ...d, enabled }));
                SET_COMPANY_INTEGRATION("sendgrid", { ...data, enabled })
                    .then((res) => { })
                    .catch(err => { setData(d => ({ ...d, enabled: !enabled })); })
            }} label="Enabled" checked={data?.enabled} />
        </Group>

        <InputField
            mt="md"
            name="api_key"
            value={data?.api_key}
            title="API KEY"
            onChange={({ api_key }) => { setData(u => ({ ...u, api_key })) }}
        />
        <Group grow mt="md">
            <InputField
                name="from_name"
                value={data?.from_name}
                title="From Name"
                onChange={({ from_name }) => { setData(u => ({ ...u, from_name })) }}
            />
            <InputField
                name="from_email"
                value={data?.from_email}
                title="From Email"
                onChange={({ from_email }) => { setData(u => ({ ...u, from_email })) }}
            />
        </Group>

        <InputField
            mt="md"
            name="template"
            value={template}
            title="Template"
            onChange={({ template }) => setTemplate(template)}
            searchable={false}
            fieldType={InputFieldTypes.SELECT}
            options={[
                { value: "verify_email", label: "E-mail verification instructions" },
                { value: "verified_email", label: "E-mail verified" },
                { value: "wallet_recharged", label: "Wallet recharged" },
                { value: "team_invite", label: "Invite to join the team" },
                { value: "forgot_password", label: "Forgot my password" },
                { value: "password_recovered", label: "Password recovered" },
                { value: "subscription_canceled", label: "Subscription canceled" },
                { value: "subscription_payment_success", label: "Subscription Payment Success" },
                { value: "subscription_payment_failed", label: "Subscription Payment Failed" },
            ]}
        />
        <InputField
            mt="md"
            name="vl"
            value={{ ...data }[template]}
            title="Template ID"
            onChange={({ vl }) => {
                setData(u => ({ ...u, [template]: vl }))
            }}
        />

        {exampleTexts[template] && <>
            <Text c="gray" mt="md">Params sent to SENDGRID in each e-mail (use these in your template):</Text>
            <Box p="md" mt="md" bg="dark">
                {exampleTexts[template].map(t => <><div style={{ whiteSpace: 'pre-wrap' }}>{t}</div></>)}
            </Box>
        </>}

        <Group justify="flex-end" mt="md">
            <Button
                size="md"
                onClick={handleSave}
                disabled={!isValid}
                loading={loadingSave}
                color="green"
            >Save Updates</Button>
        </Group>
    </>
}

const exampleTexts = {
    verify_email: [
        `{{logoImage}} - company's logo`,
        `{{name}} - user's name`,
        `{{url}} - link to verify email`,
    ],
    verified_email: [
        `{{name}} - user's name`,
    ],
    wallet_recharged: [
        `{{value}} - the value added to the wallet`,
        `{{url}} - link to the billing page`,
    ],
    team_invite: [
        `{{company_name}} - company name`,
        `{{url}} - link to accept the invite`,
    ],
    forgot_password: [
        `{{name}} - user's name`,
        `{{url}} - link to recover the password`,
    ],
    password_recovered: [
        `{{name}} - user's name`,
    ],
    subscription_canceled: [
        `{{workspace}} - workspace's name`,
    ],
    subscription_payment_success: [
        `{{workspace}} - workspace's name`,
        `{{value}} - payment amount`
    ],
    subscription_payment_failed: [
        `{{workspace}} - workspace's name`,
        `{{value}} - payment amount`
    ],
}